import React from 'react';
import style from './MealRecordCard.module.css';

/**
 * 끼니 기록 카드
 * @param {string} label    아침/점심/저녁/간식
 * @param {object|null} meal { menu, kcal, sodium, protein } | null(미기록)
 * @param {() => void} onAdd 추가 버튼 클릭
 */
const MealRecordCard = ({ label, datas, onAdd, onClick, loading = false }) => {

    /* ── 로딩 스켈레톤 ── */
    if (loading) {
        return (
            <div className={`${style.card} ${style.skeletonCard}`} aria-hidden="true">
                <div className={style.head}>
                    <div className={style.textGroup}>
                        <span className={style.skLabel} />
                        
                    </div>
                    <span className={style.skAddBtn} />
                </div>

                <ul className={style.nutri}>
                    {[0, 1, 2].map((i) => (
                        <li key={i}>
                            <span className={style.skNutriLabel} />
                            <span className={style.skNutriValue} />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
    
    const usrCalorHist = datas[datas.length - 1]; //그냥 마지막거
    const calorRecList = usrCalorHist?.calorRecList ?? [];

    const usrCalorRec = calorRecList.length > 0 ? calorRecList[calorRecList.length - 1] : null;

	// const totEnergy       = calorRecList.reduce((acc, cur) => acc + Math.round((cur.energy || 0) * 100), 0) / 100;
    // const totSodium       = calorRecList.reduce((acc, cur) => acc + Math.round((cur.sodium || 0) * 100), 0) / 100;
    // const totProtein      = calorRecList.reduce((acc, cur) => acc + Math.round((cur.protein || 0) * 100), 0) / 100;
    // const totCarbohydrate = calorRecList.reduce((acc, cur) => acc + Math.round((cur.carbohydrate || 0) * 100), 0) / 100;
    // const totFat          = calorRecList.reduce((acc, cur) => acc + Math.round((cur.fat || 0) * 100), 0) / 100;

    // 자리수 수정본
    const totEnergy = Math.round(calorRecList.reduce((acc, cur) => acc + Number(cur.energy ?? 0), 0));
    const totSodium = Math.round(calorRecList.reduce((acc, cur) => acc + Number(cur.sodium ?? 0), 0));
    const totProtein = Math.round(calorRecList.reduce((acc, cur) => acc + Number(cur.protein ?? 0), 0) * 10) / 10;
    const totCarbohydrate = Math.round(calorRecList.reduce((acc, cur) => acc + Number(cur.carbohydrate ?? 0), 0) * 10) / 10;
    const totFat = Math.round(calorRecList.reduce((acc, cur) => acc + Number(cur.fat ?? 0), 0) * 10) / 10;


    const isEmpty = !calorRecList.length;

    return (
        <div
             className={`${style.card} ${isEmpty ? style.empty : ''}`}
             onClick={onClick}
             role={onClick ? 'button' : undefined}
         >
            <div className={style.head}>
                <div className={style.textGroup}>
                    <p className={style.label}>{label}</p>
                    {isEmpty ? (
                        <p className={style.emptyText}>아직 기록이 없습니다</p>
                    ) : (
                        <p className={style.menu}>{usrCalorRec?.mainFdNm}</p>
                    )}
                </div>
                <button
                    type="button"
                    className={style.addBtn}
                    onClick={(e) => {
                         e.stopPropagation();
                         onAdd();
                    }}
                    aria-label={`${label} 식단 추가`}
                >
                </button>
            </div>

            {!isEmpty && (
                <ul className={style.nutri}>
                    <li>
                        <span className={style.nutriLabel}>칼로리</span>
                        <span className={style.nutriValue}>{totEnergy.toLocaleString('ko-KR')}<em>kcal</em></span>
                    </li>
                    <li>
                        <span className={style.nutriLabel}>나트륨</span>
                        <span className={style.nutriValue}>{totSodium.toLocaleString('ko-KR')}<em>mg</em></span>
                    </li>
                    <li>
                        <span className={style.nutriLabel}>단백질</span>
                        <span className={style.nutriValue}>{totProtein.toLocaleString('ko-KR')}<em>g</em></span>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default MealRecordCard;